// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import products from "static-data/products";
import { useDispatch, useSelector } from "react-redux";
import { getObjectValue, setObjectValue } from "commons/storage";
import DefaultProductCard from "examples/Cards/ProductCards/DefaultProductCard";
import MDTypography from "components/MDTypography";
import {
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  Modal,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  RequestNewAPI,
  GetCustomerAPIs,
  GetCustomerNotApprovedAPIs,
  RequestBulkAPISandbox,
} from "api-services";
import { LOGIN_SUCCESS } from "redux/constants";
import { ShowSuccessMessage, ShowErrorMessage } from "helpers";
import { useMaterialUIController } from "context";
import { CloseRounded } from "@mui/icons-material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

function Products() {
  const [controller, dispatch] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [notApproved, setNotApproved] = useState();
  const [password, setPassword] = useState();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openRA, setOpenRA] = useState(false);
  const handleOpenRA = () => setOpenRA(true);
  const handleCloseRA = () => setOpenRA(false);

  const [productKey, setProductKey] = useState();
  const [error, setError] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState("");

  const { darkMode } = controller;

  const userData = getObjectValue("user_data");
  let filteredProducts = products;
  let techFilteredProducts = products;
  let newProducts = [];

  if (userData?.customer?.roleId == 1) {
    filteredProducts = products.filter((prod) =>
      userData.apirequestaccessItem.find(
        (item) =>
          item.apiid == prod.key &&
          item.status == "A" &&
          (item.techStatus == "A" ||
            item.techStatus == "" ||
            item.techStatus == "P" ||
            item.techStatus == "R" ||
            item.techStatus == "W")
      )
    );
    techFilteredProducts = products.filter((prod) =>
      userData.apirequestaccessItem.find(
        (item) =>
          item.apiid == prod.key &&
          item.status == "A" &&
          (item.techStatus == "P" ||
            item.techStatus == "R" ||
            item.techStatus == "W")
      )
    );
    newProducts = products.filter(
      (prod) =>
        !filteredProducts.find((item) => item.key == prod.key) &&
        !techFilteredProducts.find((item) => item.key == prod.key)
    );
  }
  // console.log(newProducts)
  const token = useSelector((state) => state.authentication.token);
  const tokenValidity = useSelector(
    (state) => state.authentication.token_validity
  );
  const dispatchData = useDispatch();

  useEffect(() => {
    getCustomerAPIs();
    getCustomerNotApprovedAPIs();
  }, []);

  const getCustomerAPIs = () => {
    GetCustomerAPIs(
      dispatchData,
      userData?.customer?.id,
      (res) => {
        userData.apirequestaccessItem = res.data;
        setObjectValue("user_data", userData);
        let data = {
          user_data: userData,
          token: token,
          token_validity: tokenValidity,
        };

        dispatchData({ type: LOGIN_SUCCESS, payload: data });

        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };

  const getCustomerNotApprovedAPIs = () => {
    GetCustomerNotApprovedAPIs(
      dispatchData,
      userData?.customer?.id,
      (res) => {
        setNotApproved(res.data);
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };

  const requestNewAPI = (apiID) => {
    setError("");
    setLoading(true);
    if (password == "") {
      setError("Please enter your password");
      setLoading(false);
    } else {
      let data = {
        customerID: userData?.customer?.id,
        apiID: apiID,
        userEmail: userData?.customer?.email,
        apiName: products.filter((item) => item.key == apiID)[0]?.name,
        password: password,
      };
      setLoading(true);
      RequestNewAPI(
        dispatchData,
        data,
        (res) => {
          // Check if response contains error status
          if (res.data && res.data.status === "Error") {
            setShowErrorMessage(`Request Unsuccessful: ${data.apiName}`);
            setLoading(false);
            ShowErrorMessage(
              dispatch,
              "Request Failed",
              `Request Unsuccessful: ${data.apiName}`
            );
          } else {
            getCustomerAPIs();
            getCustomerNotApprovedAPIs();
            setShowSuccessMessage(`Request successfully: ${data.apiName}`);
            ShowSuccessMessage(
              dispatch,
              "Request Submitted",
              `Request successfully: ${data.apiName}`
            );
          }
        },
        (err) => {
          setShowErrorMessage(`Request Unsuccessful: ${data.apiName}`);
          setLoading(false);
          ShowErrorMessage(
            dispatch,
            "Request Failed",
            `Request Unsuccessful: ${data.apiName}`
          );
        }
      );
    }
  };

  let bgColor = darkMode ? "#1a2035" : "#fff";
  const style = {
    modal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "20%",
      bgcolor: bgColor,
      borderRadius: 2,
      border: 1,
      borderColor: bgColor,
      boxShadow: 100,
      p: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 5,
    },
  };

  const [userInfo, setUserInfo] = useState({ apiItem: [] });
  // console.log(userInfo.apiItem);
  const handleChange = (e) => {
    // Destructuring
    const { value, checked } = e.target;
    const { apiItem } = userInfo;
    // console.log(`${value} is ${checked}`);

    // Case 1 : The user checks the box
    if (checked) {
      setUserInfo({
        apiItem: [...apiItem, value],
      });
    }

    // Case 2  : The user unchecks the box
    else {
      setUserInfo({
        apiItem: apiItem.filter((e) => e !== value),
      });
    }
  };

  const requestAllAPI = () => {
    setShowErrorMessage("");
    setError("");
    setLoading(true);
    if (password === "") {
      setError("Please enter your password");
      setLoading(false);
    } else if (userInfo?.apiItem?.length <= 0) {
      setError("Please select an API");
      setLoading(false);
    } else {
      let productsData = userInfo.apiItem.map((items) => {
        return {
          customerID: userData?.customer?.id,
          apiID: items,
          userEmail: userData?.customer?.email,
          apiName: products.filter((item) => item.key == items)[0]?.name,
          password: password,
        };
      });

      const datas = {
        productsData,
      };

      const data = datas.productsData;
      setLoading(true);
      RequestBulkAPISandbox(
        dispatchData,
        data,
        (res) => {
          // Process the response to separate successful and failed APIs
          let successApis = [];
          let failedApis = [];
          let successMessage = "";
          let errorMessage = "";

          if (Array.isArray(res.data)) {
            // Separate successful and failed APIs based on response
            res.data.forEach((item) => {
              if (item.status === "Success") {
                successApis.push(item.name);
              } else if (item.status === "Error") {
                failedApis.push(item.name);
              }
            });

            // Create success message
            if (successApis.length > 0) {
              successMessage = `Request successfully: ${successApis.join(
                ", "
              )}`;
            }

            // Create error message
            if (failedApis.length > 0) {
              errorMessage = `Request Unsuccessful: ${failedApis.join(", ")}`;
            }
          } else if (res.data && res.data.status === "Error") {
            // Fallback for non-array response
            errorMessage = `Request Unsuccessful`;
          }

          // Handle success cases
          if (successApis.length > 0) {
            getCustomerAPIs();
            getCustomerNotApprovedAPIs();
            setShowSuccessMessage(successMessage);
            ShowSuccessMessage(
              dispatch,
              "Request Submitted",
              `Request successfully: ${successApis.join(", ")}`
            );
          }

          // Handle error cases
          if (failedApis.length > 0) {
            setShowErrorMessage(errorMessage);
            ShowErrorMessage(
              dispatch,
              "Request Failed",
              `Request Unsuccessful: ${failedApis.join(", ")}`
            );
          }

          // Clear fields and stop loading
          if (successApis.length > 0 && failedApis.length === 0) {
            clearFields();
            handleCloseRA();
          }
          setLoading(false);
        },
        (err) => {
          let apiNames = productsData.map((item) => item.apiName).join(", ");
          setShowErrorMessage(`Request Unsuccessful: ${apiNames}`);
          setLoading(false);
          ShowErrorMessage(
            dispatch,
            "Request Failed",
            `Request Unsuccessful: ${apiNames}`
          );
        }
      );
    }
  };

  const clearFields = () => {
    setUserInfo({ apiItem: [] });
    setShowErrorMessage("");
    setError("");
    setShowSuccessMessage("");
  };

  const newProd = newProducts?.length || 0; // Default to 0 if undefined
  const notApprovedApis =
    notApproved?.filter(
      (val) => val.status === "P" || val.status === "R" || val.status === "W"
    ) || []; // Default to an empty array if undefined
  const notApprovedCount = notApprovedApis.length;
  const nonRequestedApis = newProd - notApprovedCount; // Calculate non-requested APIs

  const shouldDisplayButton = () => {
    return (
      (notApprovedCount > 0 || nonRequestedApis > 0) && // At least one not approved or non-requested
      notApprovedCount < newProd && // Not all are not approved
      userData?.customer?.roleId === 1 && // User role check
      nonRequestedApis > 1 // More than one non-requested API
    );
  };

  const handleButtonClick = () => {
    handleOpenRA();
    setPassword("");
    setShowErrorMessage("");
    setError("");
    setShowSuccessMessage("");
    setUserInfo({ apiItem: [] });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        {userData?.customer?.roleId == 2 ||
        userData?.customer?.roleId == 3 ||
        userData?.customer?.roleId == 4 ||
        userData?.customer?.roleId == 5 ? (
          <MDBox pt={2} px={2} lineHeight={1.25}>
            <MDTypography variant="h6" fontWeight="medium">
              Products VCT API
            </MDTypography>
            <MDBox mb={1}>
              <MDTypography variant="button" color="text">
                All products are listed below.
              </MDTypography>
            </MDBox>
          </MDBox>
        ) : (
          <MDBox pt={2} px={2} lineHeight={1.25}>
            <MDTypography variant="h6" fontWeight="medium">
              Subscribed Products
            </MDTypography>
            <MDBox mb={1}>
              <MDTypography variant="button" color="text">
                Your subscribed Products are listed below.
              </MDTypography>
            </MDBox>
          </MDBox>
        )}

        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <Grid container spacing={3}>
                {filteredProducts.map(
                  ({ name, description, image, imageDark, key, route }) => {
                    return (
                      <Grid item xs={12} md={6} xl={2} key={key}>
                        <DefaultProductCard
                          icon=""
                          to={route}
                          onClick={() => {}}
                          title={name}
                          description={description}
                          image={image}
                          imageDark={imageDark}
                          subscribed={true}
                          productID={key}
                          key={key}
                          sandbox={
                            userData?.customer?.roleId == 1 &&
                            userData.apirequestaccessItem.find(
                              (val) =>
                                val.apiid == key &&
                                val.status == "A" &&
                                val.sandbox != null
                            )
                          }
                          production={
                            userData?.customer?.roleId == 1 &&
                            (key === 3
                              ? userData.apirequestaccessItem.find(
                                  (val) =>
                                    val.apiid == key &&
                                    val.status == "A" &&
                                    val.productionStatus == "A" &&
                                    val.techStatus == "A"
                                )
                              : userData.apirequestaccessItem.find(
                                  (val) =>
                                    val.apiid == key &&
                                    val.status == "A" &&
                                    val.productionStatus == "A"
                                ))
                          }
                        />
                      </Grid>
                    );
                  }
                )}
              </Grid>
            </Grid>
          </Grid>
        </MDBox>

        {newProducts?.length > 0 && userData?.customer?.roleId == 1 ? ( //|| techFilteredProducts.length > 0
          <div>
            <Divider orientation="horizontal" sx={{ ml: -2, mr: 1 }} />
            <Grid container spacing={3}>
              <Grid item xs={12} lg={9}>
                <MDBox pt={2} px={2} lineHeight={1.25}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Other Available Products
                  </MDTypography>
                  <MDBox mb={1}>
                    <MDTypography variant="button" color="text">
                      Subscribe to our other Products.
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </Grid>
              <Grid item xs={12} lg={3}>
                {shouldDisplayButton() && (
                  <MDButton
                    variant="gradient"
                    size="large"
                    sx={{
                      background: "linear-gradient(195deg, #66BB6A, #43A047)",
                      float: "right",
                      textTransform: "capitalize",
                      fontSize: "16px",
                      minWidth: "264px",
                    }}
                    color={darkMode ? "white" : "#ddeede"}
                    onClick={handleButtonClick}
                  >
                    Request ALL APIs
                  </MDButton>
                )}
              </Grid>
            </Grid>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={8}>
                  <Grid container spacing={3}>
                    {newProducts.map(
                      ({ name, description, image, imageDark, key }) => {
                        return (
                          <Grid item xs={12} md={6} xl={3} key={key}>
                            <DefaultProductCard
                              icon=""
                              onClick={() => {
                                handleOpen();
                                setPassword("");
                                setProductKey(key);
                                setLoading(false);
                                setError("");
                                setShowErrorMessage("");
                                setShowSuccessMessage("");
                              }}
                              title={name}
                              description={description}
                              image={image}
                              imageDark={imageDark}
                              subscribed={false}
                              loading={loading}
                              productID={key}
                              pending={
                                userData?.customer?.roleId === 1 &&
                                notApproved?.some(
                                  (val) =>
                                    val.status === "P" && val.apiid === key
                                )
                              }
                              inReview={
                                userData?.customer?.roleId === 1 &&
                                notApproved?.some(
                                  (val) =>
                                    val.status === "R" && val.apiid === key
                                )
                              }
                              rejected={
                                userData?.customer?.roleId === 1 &&
                                notApproved?.some(
                                  (val) =>
                                    val.status === "W" && val.apiid === key
                                )
                              }
                            />
                          </Grid>
                        );
                      }
                    )}

                    {/* {
                        techFilteredProducts.length > 0 ?
                          techFilteredProducts.map(({ name, description, image, imageDark, key }) => {
                            return <Grid item xs={12} md={6} xl={3}>
                              <DefaultProductCard
                                icon=""
                                onClick=""
                                title={name}
                                description={description}
                                image={image}
                                imageDark={imageDark}
                                subscribed={false}
                                loading={loading}
                                productID={key}
                                key={key}
                                pending={userData?.customer?.roleId == 1 && userData.apirequestaccessItem.filter((val) => val.status == "A" && val.techStatus == "P").length > 0 ? true : false}
                                inReview={userData?.customer?.roleId == 1 && userData.apirequestaccessItem.filter((val) => val.status == "A" && val.techStatus == "R").length > 0 ? true : false}
                                rejected={userData?.customer?.roleId == 1 && userData.apirequestaccessItem.filter((val) => val.status == "A" && val.techStatus == "W").length > 0 ? true : false}
                              />
                            </Grid>
                          })
                          : ""
                      } */}
                  </Grid>
                </Grid>
              </Grid>
            </MDBox>
          </div>
        ) : (
          <></>
        )}
      </MDBox>
      <Footer />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="responsive-modal"
      >
        <MDBox sx={style.modal} className="mobile-size-modal">
          <MDBox mb={1}>
            <MDBox onClick={handleClose} className="close-modal-sm">
              <CloseRounded color={darkMode ? "white" : "secondary"} />
            </MDBox>
            <MDTypography
              variant="h6"
              mb={1}
              fontWeight="regular"
              fontSize="14px"
            >
              Confirm your password <span className="starik">*</span>
            </MDTypography>
            <MDInput
              type="password"
              label="Enter Password"
              color="success"
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              className="inputbox mb-2"
              required
            />
            {error && (
              <MDTypography
                color="error"
                variant="subtitle2"
                sx={{ fontSize: "12px", textAlign: "center" }}
              >
                {error}
              </MDTypography>
            )}
            {showErrorMessage != "" && (
              <MDTypography
                color="error"
                variant="subtitle2"
                sx={{
                  fontSize: "12px",
                  textAlign: "center",
                  whiteSpace: "pre-line",
                }}
              >
                {showErrorMessage}
              </MDTypography>
            )}
            {showSuccessMessage != "" && (
              <MDTypography
                color="success"
                variant="subtitle2"
                sx={{
                  fontSize: "12px",
                  textAlign: "center",
                  whiteSpace: "pre-line",
                }}
              >
                {showSuccessMessage}
              </MDTypography>
            )}
            <MDButton
              sx={{
                width: "100%",
                marginTop: "10px",
                paddingTop: "15px",
                paddingBottom: "15px",
              }}
              variant="gradient"
              color="success"
              onClick={() => {
                requestNewAPI(productKey);
              }}
            >
              {loading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                `Request API`
              )}
            </MDButton>
          </MDBox>
        </MDBox>
      </Modal>

      {/* Request ALL APIs Modal */}
      <Modal
        open={openRA}
        onClose={handleCloseRA}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="responsive-modal"
      >
        <MDBox sx={style.modal} className="mobile-size-modal">
          <MDBox mb={1}>
            <MDBox onClick={handleCloseRA} className="close-modal-sm">
              <CloseRounded color={darkMode ? "white" : "secondary"} />
            </MDBox>
            <MDTypography variant="h5" mb={2}>
              Request All APIs
            </MDTypography>
            <FormGroup className="req-all" mb={2}>
              {newProducts?.map((item, index) => {
                if (
                  userData?.customer?.roleId == 1 &&
                  notApproved?.filter(
                    (val) =>
                      (val.status == "P" ||
                        val.status == "R" ||
                        val.status == "W") &&
                      val.apiid == item.key
                  )?.length <= 0
                ) {
                  return (
                    <FormControlLabel
                      fontWeight="regular"
                      key={item.key}
                      onChange={handleChange}
                      value={item.key}
                      control={<Checkbox />}
                      label={item.name}
                    />
                  );
                }
              })}
            </FormGroup>

            <MDTypography
              variant="h6"
              fontWeight="regular"
              fontSize="14px"
              my={1}
            >
              Confirm your password <span className="starik">*</span>
            </MDTypography>
            <MDInput
              type="password"
              label="Enter Password"
              color="success"
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              className="inputbox mt-2 mb-2"
              required
            />
            {error && (
              <MDTypography
                color="error"
                variant="subtitle2"
                sx={{ fontSize: "12px", textAlign: "center" }}
              >
                {error}
              </MDTypography>
            )}
            {showErrorMessage != "" && (
              <MDTypography
                color="error"
                variant="subtitle2"
                sx={{
                  fontSize: "12px",
                  textAlign: "center",
                  whiteSpace: "pre-line",
                }}
              >
                {showErrorMessage}
              </MDTypography>
            )}
            {showSuccessMessage != "" && (
              <MDTypography
                color="success"
                variant="subtitle2"
                sx={{
                  fontSize: "12px",
                  textAlign: "center",
                  whiteSpace: "pre-line",
                }}
              >
                {showSuccessMessage}
              </MDTypography>
            )}
            <MDButton
              sx={{
                width: "100%",
                marginTop: "10px",
                paddingTop: "15px",
                paddingBottom: "15px",
              }}
              variant="gradient"
              color="success"
              onClick={() => {
                requestAllAPI();
              }}
            >
              {loading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                `Request API`
              )}
            </MDButton>
          </MDBox>
        </MDBox>
      </Modal>
    </DashboardLayout>
  );
}

export default Products;
